import createIcon from '../../createIcon';

/**
 * @component @name SyncLock
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS41IDMuMjZWNS4zNUM3LjE3IDYuMTggNS41IDguMzkgNS41IDExQzUuNSAxMi43NyA2LjI4IDE0LjM0IDcuNSAxNS40NFYxM0g5LjVWMTlIMy41VjE3SDYuMjNDNC41NiAxNS41NCAzLjUgMTMuNCAzLjUgMTFDMy41IDcuMjcgNi4wNSA0LjE1IDkuNSAzLjI2Wk0xOS41IDNIMTMuNVY5SDE1LjVWNi41NkMxNi43MiA3LjY2IDE3LjUgOS4yMyAxNy41IDExSDE5LjVDMTkuNSA4LjYgMTguNDQgNi40NiAxNi43NyA1SDE5LjVWM1pNMTkuNSAxNlYxNUMxOS41IDEzLjkgMTguNiAxMyAxNy41IDEzQzE2LjQgMTMgMTUuNSAxMy45IDE1LjUgMTVWMTZDMTQuOTUgMTYgMTQuNSAxNi40NSAxNC41IDE3VjIwQzE0LjUgMjAuNTUgMTQuOTUgMjEgMTUuNSAyMUgxOS41QzIwLjA1IDIxIDIwLjUgMjAuNTUgMjAuNSAyMFYxN0MyMC41IDE2LjQ1IDIwLjA1IDE2IDE5LjUgMTZaTTE4LjUgMTZIMTYuNVYxNUMxNi41IDE0LjQ1IDE2Ljk1IDE0IDE3LjUgMTRDMTguMDUgMTQgMTguNSAxNC40NSAxOC41IDE1VjE2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SyncLock = createIcon('SyncLock', [
  [
    'path',
    {
      d: 'M9.5 3.26V5.35C7.17 6.18 5.5 8.39 5.5 11C5.5 12.77 6.28 14.34 7.5 15.44V13H9.5V19H3.5V17H6.23C4.56 15.54 3.5 13.4 3.5 11C3.5 7.27 6.05 4.15 9.5 3.26ZM19.5 3H13.5V9H15.5V6.56C16.72 7.66 17.5 9.23 17.5 11H19.5C19.5 8.6 18.44 6.46 16.77 5H19.5V3ZM19.5 16V15C19.5 13.9 18.6 13 17.5 13C16.4 13 15.5 13.9 15.5 15V16C14.95 16 14.5 16.45 14.5 17V20C14.5 20.55 14.95 21 15.5 21H19.5C20.05 21 20.5 20.55 20.5 20V17C20.5 16.45 20.05 16 19.5 16ZM18.5 16H16.5V15C16.5 14.45 16.95 14 17.5 14C18.05 14 18.5 14.45 18.5 15V16Z',
      key: '1klji2',
    },
  ],
]);

export default SyncLock;
